import React from 'react';
import { Filter } from 'lucide-react';

interface ClientFiltersProps {
  selected: string;
  onSelect: (filter: string) => void;
}

export function ClientFilters({ selected, onSelect }: ClientFiltersProps) {
  const filters = [
    { id: 'all', label: 'All' },
    { id: 'Elite Performance', label: 'Elite' },
    { id: 'Strength Builder', label: 'Strength' },
    { id: 'HIIT Master', label: 'HIIT' },
    { id: 'Recovery', label: 'Recovery' }
  ];

  return (
    <div className="flex items-center gap-2">
      <Filter className="w-4 h-4 text-muted-foreground" />
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => onSelect(filter.id)}
          className={`px-3 py-1.5 rounded-lg text-sm transition-colors ${
            selected === filter.id
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-muted-foreground hover:bg-muted/70'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
}